import '@/speech-recognition-init';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
// Imported here, not from src/styles/index.css, so Vite rebases the library's
// font url()s; postcss-import would leave them pointing at src/.
import '../node_modules/stubben-edge-unified-frontend-react-components/dist/esm/index.css';
import './index.css';
import './tenant-brand-font.css';
import 'react-toastify/dist/ReactToastify.css';

const container = document?.getElementById('root');
if (container) {
  const root = createRoot(container);

  root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  );
}
